export const ReportIdConst = {
  ActiveWarrantListWithMugshot: '264',
  CitationReport: '274',
  ActiveWarrantReport: '275',
  IncidentByLocationSummary: '276',
  IncidentByLocationDetail: '277',
  IncidentSeverityByZone: '278',
  OffenseChargesByState: '279',
  OffenseChargesByCity: '280',
  CitationStatisticsReport: '299',
  CleryReport: '323',
};
